module.exports = __webpack_public_path__ + "static/img/zycs.896fd93d.png";